import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'gatsby';

import { useGraphQL, useLazyLoad } from '../hooks';
import { resizeShopifyImage } from '../utils';

function Tile({ title, slug, image, price }) {
  const { ref, srcRef, isLoaded, handleIsLoaded, Spinner } = useLazyLoad();
  // TODO: Change to proper Moda Latina placeholder img

  const { placeholderImage } = useGraphQL();
  let imageSrc = placeholderImage.publicURL;
  if (image?.originalSrc)
    imageSrc = resizeShopifyImage({ url: image.originalSrc, width: 292 });
  if (typeof image === 'string') imageSrc = image;

  return (
    <article>
      <Link to={slug} className="relative block h-0 aspect-ratio-square">
        <div ref={ref} className="absolute inset-0">
          <img
            ref={srcRef}
            data-src={imageSrc}
            onLoad={handleIsLoaded}
            alt=""
            className="object-cover w-full h-full"
          />
          {!isLoaded && <Spinner />}
        </div>
      </Link>
      <div className="flex justify-between mt-2 tracking-wider uppercase text-dark-pink">
        <div>{title}</div>
        <div>${price}</div>
      </div>
    </article>
  );
}

Tile.propTypes = {
  image: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  price: PropTypes.number.isRequired,
  slug: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

export { Tile };
